import React, { Component } from 'react';
import { TweenLite } from 'gsap';
import Menu from './Menu';

class NavNarrow extends Component {
	constructor(props) {
		super(props);
		this.body = React.createRef();
	}
	componentDidUpdate(prevProps) {
		if (prevProps.open !== this.props.open && this.props.open) {
			TweenLite.from( this.body.current, 0.1, { 
				opacity: 0, y: -15,
				clearProps: "all"
			} );
		}
	}
	closeMenu = () => {
		TweenLite.to( this.body.current, 0.1, {
			opacity: 0, y: -15,
			clearProps: "all",
			onComplete: this.props.onMenuExit
		} );
	}
	render() {
		const menus = this.props.menus || [];
		const bodyContent = menus.map( (data) => {
			const { slug, title, items } = data;
			return <Menu 
				key={slug} 
				slug={slug}
				title={title} 
				items={items} 
				open={slug === this.props.current}
				mode="narrow"
			/>;
		} );
		const toggleMenu = (e) => {
			if (this.props.open) { this.closeMenu() }
			else {this.props.onMenuEnter(); }
		}
		
		return (
			<nav id="Nav">
				<div id="Nav-toggle" onClick={toggleMenu}><span>{this.props.title}</span></div>
				<div id="Nav-body" ref={this.body}>
					{bodyContent}
				</div>
			</nav>
		)
	}
}

export default NavNarrow;


// WEBPACK FOOTER //
// ./src/components/Header/Nav/NavNarrow.jsx